export default "__VITE_ASSET__fa1fd627__"